module.exports = __webpack_public_path__ + "img/suspensionPoint1.8cb69526.png";